import axios from 'axios';

export default {
  FETCH_CHARITIES ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('user/getAllGiving')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('charities', JSON.stringify(payload));
                    commit('SET_CHARITIES', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDCHARITY ({ commit }, givingId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`user/getAllGiving`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;
            console.log('payload', payload)
            let selectedCharity = payload.filter(x => {
              return x.givingId.toString() === givingId.toString()
            });
            console.log('found banner', selectedCharity)
            commit('SET_SELECTED_CHARITY', selectedCharity[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_CHARITY({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add Charity payload : ", payload);
            axios.post('user/insertGiving', payload)
                .then((response) => {
                    console.log('ADD_CHARITY action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_CHARITY action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_CHARITY({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/user/updateGiving', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_CHARITY action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/charities/actions.js